import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'

/**
 * Base
 */
// Debug
const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()

const particulesTexture = textureLoader.load('/particules_textures/1.png')

/**
 * Particules
 */
// Geometry

const parameters = {}
parameters.count = 1000
parameters.size = 10


let particules = null
let particulesGeometry = null
let particulesMaterial = null

const createParticules = () => {

    if(particules) {
        particulesGeometry.dispose()
        particulesMaterial.dispose()
        scene.remove(particules)
    }
    const count = parameters.count
    particulesGeometry = new THREE.BufferGeometry()
    
    const positions = new Float32Array(count * 3)
    const colors = new Float32Array(count * 3)

    for(let i = 0; i < count * 3; i++) {
        positions[i] = (Math.random() - 0.5) * parameters.size
        colors[i] = Math.random()
    }
    
    particulesGeometry.setAttribute(
        'position',
        new THREE.BufferAttribute(positions, 3)
    )
    
    particulesGeometry.setAttribute(
        'color',
        new THREE.BufferAttribute(colors, 3)
    )
    
    // Material
    particulesMaterial = new THREE.PointsMaterial({
        size: 0.1,
        sizeAttenuation: true,
        alphaMap: particulesTexture,
        transparent: true,
        // alphaTest: 0.001,
        // depthTest: false,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        vertexColors: true
    })
    
    // Points
    particules = new THREE.Points(particulesGeometry, particulesMaterial)
    scene.add(particules)
}

createParticules()

gui.add(parameters, 'count').min(100).max(1000000).step(100).onChange(createParticules)
gui.add(parameters, 'size').min(5).max(100).step(5).onChange(createParticules)



/**
 * Test cube
 */
// const cube = new THREE.Mesh(
//     new THREE.BoxGeometry(1, 1, 1),
//     new THREE.MeshBasicMaterial({
//         // color: 'green'
//     })
// )
// scene.add(cube)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 3
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Pzrticules animation
    // particules.rotation.y = elapsedTime * 0.2
    for(let i = 0; i < parameters.count; i++) {
        const i3 = i * 3
        
        const x = particulesGeometry.attributes.position.array[i3]
        const y = particulesGeometry.attributes.position.array[i3 + 1]
        const z = particulesGeometry.attributes.position.array[i3 + 2]


        particulesGeometry.attributes.position.array[i3 + 1] = Math.sin(elapsedTime + x) * Math.cos(elapsedTime + z)
        particulesGeometry.attributes.position.needsUpdate = true
    }

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()